import { NavigationContext } from '@/shared/NavigationContext/NavigationContext';
import { usePlausibleContext } from '@/shared/PlausibleAnalytics/PlausibleAnalytics';
import { useContext } from 'react';

export default function useSearchThemes() {
  const navigationContext = useContext(NavigationContext);
  const plausibleContext = usePlausibleContext();

  const actions = {
    setSearchText: (e) => {
      navigationContext.actions.setPageData('themes', {
        ...navigationContext.state.pagesData.themes,
        searchText: e.target?.value,
      });
    },
    setActivityType: (activityType) => {
      navigationContext.actions.setPageData('themes', {
        ...navigationContext.state.pagesData.themes,
        activityType,
      });
      plausibleContext.actions.sendPlausibleEvent('button_click', {
        action: 'filter_activity_type',
        activityType,
      });
    },
  };

  return {
    state: {
      ...navigationContext.state.pagesData.themes,
    },
    actions,
  };
}
